import heroImg1Desktop from 'assets/images/brushesLp/d-hero-left.jpg';
import heroImg2Desktop from 'assets/images/brushesLp/d-hero-right.jpg';
import introImgDesktop from 'assets/images/brushesLp/d-module-2-new.jpg';
import boarImgDesktop from 'assets/images/brushesLp/d-module-3_boar.jpg';
import detanglingImgDesktop from 'assets/images/brushesLp/d-module-3_detangling.jpg';
import mixedImgDesktop from 'assets/images/brushesLp/d-module-3_mixed.jpg';
import bottomImgDesktop from 'assets/images/brushesLp/d-module-4-bottom.jpg';
import topImgDesktop from 'assets/images/brushesLp/d-module-4-top-new.jpg';
import armImgDesktop from 'assets/images/brushesLp/d-module-6.jpg';
import herkunftImg1Desktop from 'assets/images/brushesLp/dt-how-its-made-1.jpg';
import herkunftImg2Desktop from 'assets/images/brushesLp/dt-how-its-made-2.jpg';
import herkunftImg3Desktop from 'assets/images/brushesLp/dt-how-its-made-3.jpg';
import heroImg2Mobile from 'assets/images/brushesLp/m-hero-bottom.jpg';
import heroImg1Mobile from 'assets/images/brushesLp/m-hero-top.jpg';
import herkunftImg1Mobile from 'assets/images/brushesLp/m-how-its-made-1.jpg';
import herkunftImg2Mobile from 'assets/images/brushesLp/m-how-its-made-2.jpg';
import introImgMobile from 'assets/images/brushesLp/m-module-2-new.jpg';
import bottomImgMobile from 'assets/images/brushesLp/m-module-4-bottom.jpg';
import topImgMobile from 'assets/images/brushesLp/m-module-4-top-new.jpg';
import armImgMobile from 'assets/images/brushesLp/m-module-6.jpg';
import heroImg2Tablet from 'assets/images/brushesLp/t-hero-bottom.jpg';
import heroImg1Tablet from 'assets/images/brushesLp/t-hero-top.jpg';
import introImgTablet from 'assets/images/brushesLp/t-module-2-new.jpg';
import bottomImgTablet from 'assets/images/brushesLp/t-module-4-bottom.jpg';
import topImgTablet from 'assets/images/brushesLp/t-module-4-top-new.jpg';
import armImgTablet from 'assets/images/brushesLp/t-module-6.jpg';
import boarImgMobile from 'assets/images/brushesLp/tm-module-3_boar.jpg';
import detanglingImgMobile from 'assets/images/brushesLp/tm-module-3_detangling.jpg';
import mixedImgMobile from 'assets/images/brushesLp/tm-module-3_mixed.jpg';
import { ReactComponent as VeganSymbol } from 'assets/images/brushesLp/vegan-symbol.svg';

export const content = {
  hero: {
    eyebrow1: 'A collection of three hand-crafted brushes.',
    eyebrow2: 'Made in France. Monogrammed in Brooklyn.',
    headline1: (
      <>
        We believe objects that <i>care</i> for you
      </>
    ),
    headline2: (
      <>
        should be made with equal <i>care</i>
      </>
    ),
    image1Desktop: heroImg1Desktop,
    image2Desktop: heroImg2Desktop,
    image1Tablet: heroImg1Tablet,
    image2Tablet: heroImg2Tablet,
    image1Mobile: heroImg1Mobile,
    image2Mobile: heroImg2Mobile,
  },
  intro: {
    headline: 'Introducing a collection of very personal brushes',
    body:
      'Made with time-honored tradition and destined for a lifetime of luxury, these are hairbrushes made to care for you like no other. ' +
      'Find your perfect match—or perfect gift—and add a monogram to make it your most personal essential yet.',
    cta: 'Shop Brushes',
    img: {
      imageDesktop: introImgDesktop,
      imageTablet: introImgTablet,
      imageMobile: introImgMobile,
    },
  },
  collection: {
    headline: 'Meet the collection',
    brushes: (price: string) => [
      {
        title: 'Boar Bristle brush',
        subTitle: 'For fine to medium hair',
        description:
          'We sourced 100% boar bristle and used only the root (a sign of luxury in the brush world). ' +
          'It’s the ideal balance of softness and strength',
        footerText: price,
        vegan: false,
        images: { desktop: boarImgDesktop, mobile: boarImgMobile, alt: 'Boar Bristle' },
      },
      {
        title: 'Boar & Nylon Bristle',
        subTitle: 'For medium to thick hair',
        description:
          'Double-duty bristles work two ways: longer nylon gently stimulating the scalp and detangling ends; ' +
          'shorter boar redistributing oil through lengths',
        footerText: price,
        vegan: false,
        images: {
          desktop: mixedImgDesktop,
          mobile: mixedImgMobile,
          alt: 'Boar & Nylon Bristle brush',
        },
      },
      {
        title: 'Tipped-Metal Bristle',
        icon: <VeganSymbol />,
        subTitle: 'For thick or curly hair',
        description:
          'Wire bristles sway with your strands to add definition and detangle—resilient but flexible enough to remove fragile knots',
        footerText: price,
        vegan: true,
        images: {
          desktop: detanglingImgDesktop,
          mobile: detanglingImgMobile,
          alt: 'Tipped-Metal Bristle',
        },
      },
    ],
    cta: 'Find your brush',
  },
  handsOn: {
    headline: 'Hands On',
    body: (
      <>
        Your grandmother’s “100 strokes a day” rule was onto something. Brushing with the right
        bristle enhances your hair from root to tip: stimulating the scalp, distributing oil,
        detangling ends, and giving all-over luster. It’s the original beauty multitasker — the{' '}
        <i>sine qua non</i> of every routine.
      </>
    ),
    cta: 'Read our expert brushing guide',
    ctaArticleUrl: 'https://prose.com/blog/expert-hair-brushing-guide.php',
    imageTopAlt:
      'Artistic title that reads "Hands On", overlaying a three image grid of: a Boar & Nylon Bristle brush resting on a block, the side of a woman\'s face with short blond hair and the back of a woman\'s neck showing her brushing her short black hair.',
    imageBottomAlt:
      'Artistic title that reads "Hands On", overlaying a three image grid of: the back of woman\'s head with long gray hair, a woman brushing one side of her long blond hair, and a Boar & Nylon Brsitle brush resting on clay blocks.',
    imageTopDesktop: topImgDesktop,
    imageBottomDesktop: bottomImgDesktop,
    imageTopTablet: topImgTablet,
    imageBottomTablet: bottomImgTablet,
    imageTopMobile: topImgMobile,
    imageBottomMobile: bottomImgMobile,
  },
  arm: {
    title: 'Every Piece',
    bullets: [
      {
        title: '1. Bristle',
        content: 'The gold standard in boar bristles (and 24k vegan options too)',
      },
      {
        title: '2. Cushion',
        content: 'A naturally-sourced rubber cushion for the perfect amount of give',
      },
      {
        title: '3. Handle',
        content: 'Made of lightweight beechwood and hand-polished to be elegant, yet grippable',
      },
      { title: '4. Monogram', content: 'Any three initials hand-engraved at our Brooklyn studio' },
    ],
    titleBis: <>Crafted By&nbsp;Hand</>,
    descriptionBis:
      'For truly professional quality, we went to the professionals. ' +
      'Our brushes are expertly handcrafted by artisans practiced in the specific skill of brush-making (Vive la France) who forge each brush from sustainable European beechwood and hevea rubber.',
    cta: 'Behind the process',
    ctaArticleUrl: 'https://prose.com/blog/prose-hair-brushes-behind-the-process.php',
    imageDesktop: armImgDesktop,
    imageTablet: armImgTablet,
    imageMobile: armImgMobile,
    herkunftDesktop: [
      {
        alt: 'Black and white image of hands sanding down a brush paddle in a factory.',
        image: herkunftImg1Desktop,
      },
      {
        alt: 'Black and white image of hands using machine to stamp the word Prose onto a brush handle.',
        image: herkunftImg2Desktop,
      },
      {
        alt: 'Black and white image of a person inspecting the final brush product.',
        image: herkunftImg3Desktop,
      },
    ],
    herkunftMobile: [
      {
        alt: 'Black and white image of hands sanding down a brush paddle in a factory.',
        image: herkunftImg1Mobile,
      },
      {
        alt: 'Black and white image of hands using machine to stamp the word Prose onto a brush handle.',
        image: herkunftImg2Mobile,
      },
    ],
  },
  faq: {
    title: 'Frequently asked questions',
    questions: [
      {
        question:
          "I'm not seeing a recomended option when I select my brush—how do I choose the right one?",
        answer: (
          <>
            Simply log in or complete your Haircare consultation and you’ll see a recommended Brush
            that best fits your hair needs. If you are purchasing a Brush as a gift, you can select
            whichever one suits the recipient’s needs. We have an article{' '}
            <a href="https://prose.com/blog/expert-hair-brushing-guide.php" target="_blank">
              here
            </a>{' '}
            to help guide you.
          </>
        ),
      },
      {
        question: 'Are special characters allowed for monogramming?',
        answer:
          'Prose brushes can only be monogrammed in letters A-Z. Please note that all initials will be in uppercase.',
      },
      {
        question: 'How will my brush arrive? ',
        answer:
          'Your brush will ship in a dedicated box, separate from other products purchased and without an invoice making it a perfect gift for yourself or for loved ones. ',
      },
      {
        question: 'How should I care for my Prose brush?',
        answer:
          'Each Prose brush will arrive with detailed use instructions and care tips. But in all cases, limit exposure to high heat as your brush is crafted to be a care product rather than a styling tool. Also, be sure to store your brush on its back in a dry area.',
      },
      {
        question: 'What is the Prose brush return policy?',
        answer: (
          <>
            Every Prose brush is covered by The Prose Promise™ — Love your first order (or it’s on
            us) within 30 days of the delivery date. If you received your brush as a gift, it can be
            returned for credit to your Prose account—rest assured the purchaser won’t be notified.
            <br />
            <br />
            In addition, each brush is backed by a full warranty should you notice a rare material
            defect or workmanship defect within 30 days. For any issues that fall under the
            warranty, just contact our team{' '}
            <a href="https://prose.com/faq/contact-us" target="_blank">
              here
            </a>{' '}
            to coordinate a complimentary replacement. Please note that the warranty does not cover
            normal wear and tear, misuse, or alteration of brushes—so be sure to follow the care
            tips provided with your order.
          </>
        ),
      },
    ],
  },
};
